import { DetectPlatformService } from '@alliance/shared/utils'
import { AfterContentInit, Directive, Inject, Input } from '@angular/core'
import { debounceTime, filter, take, map } from 'rxjs'
import { AtsGtmEvent, AtsGtmEventLabelDefault, PushAnalyticsEventsService } from '@alliance/ats/analytics/utils'
import { RxState } from '@rx-angular/state'
import { INTERSECTION_THRESHOLD, IntersectionObserverService } from '@alliance/cdk/viewport'

@Directive({
  selector: '[atsAnalyticsPushEventOnView]',
  providers: [
    IntersectionObserverService,
    {
      provide: INTERSECTION_THRESHOLD,
      useValue: 1
    }
  ]
})
export class PushEventOnViewDirective<Label extends AtsGtmEventLabelDefault> extends RxState<object> implements AfterContentInit {
  @Input() public event: AtsGtmEvent<Label> | null = null
  @Input() public debounceTime = 0
  @Input() public isOneTime = true

  public constructor(
    private platform: DetectPlatformService,
    private pushAnalyticsEventsService: PushAnalyticsEventsService,
    @Inject(IntersectionObserverService) private entries$: IntersectionObserverService
  ) {
    super()
  }

  public ngAfterContentInit(): void {
    if (this.platform.isBrowser) {
      this.hold(
        this.entries$.pipe(
          filter(entries => entries[0].isIntersecting),
          debounceTime(this.debounceTime),
          map(() => this.event),
          filter(Boolean),
          source => (this.isOneTime ? source.pipe(take(1)) : source)
        ),
        event => this.pushAnalyticsEventsService.pushEvent(event)
      )
    }
  }
}
